import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import classnames from 'classnames';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import FakeButton from './FakeButton';
import s from './PlainButtonOrLink.scss';
const PlainButtonOrLink = (_param)=>{
    var { className, isFakeButton, onClick = ()=>null } = _param, rest = _object_without_properties(_param, [
        "className",
        "isFakeButton",
        "onClick"
    ]);
    const href = rest.href;
    const classNames = classnames(href ? s['link'] : s['button'], isFakeButton && s['fake-button'], className);
    const props = _object_spread({
        className: classNames
    }, rest);
    return href ? /*#__PURE__*/ React.createElement(BiLink, _object_spread({
        onClick: onClick
    }, props)) : !isFakeButton ? /*#__PURE__*/ React.createElement(BiButton, _object_spread({
        onClick: onClick
    }, props)) : // There are some instances where we need to render a button inside of a button. This is not correct HTML.
    // To solve this use-case, the following is a fake button using role="button" and the correct event handlers.
    /*#__PURE__*/ React.createElement(FakeButton, _object_spread({
        tabIndex: 0,
        onClick: onClick
    }, props));
};
PlainButtonOrLink.displayName = 'PlainButtonOrLink';
export default PlainButtonOrLink;
